import React from 'react';
import Home from './screens/home/index'


function App() {
  
  return (
    <div>
      <Home/>  
    </div>
  );
}

export default App;
